import { MapPin, Phone, CalendarCheck } from "lucide-react";
import { CONTACT, openChat } from "@/config/site";
import { Reveal, SectionHeading } from "./Motion";
import { WhatsAppIcon } from "./WhatsAppIcon";

const Row = ({ icon: Icon, label, value, href, testId, external }) => (
  <a
    href={href}
    data-testid={testId}
    {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    className="glass card-lift flex h-full items-center gap-5 rounded-3xl p-6"
  >
    <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-gold/10 ring-1 ring-gold/30">
      <Icon className="h-6 w-6 text-gold-ink" />
    </span>
    <span>
      <span className="block text-sm uppercase tracking-[0.18em] text-slate-500">{label}</span>
      <span className="mt-1 block text-lg sm:text-xl font-semibold text-navy-900">{value}</span>
    </span>
  </a>
);

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="section-pad relative bg-cream-100">
    <div className="container-x">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading eyebrow="Contact" title="Get in Touch" sub="Call now for a free site visit." />
        <Reveal>
          <button onClick={openChat} data-testid="contact-free-visit-button" className="btn-gold h-14 w-full px-8 text-lg lg:w-auto">
            <CalendarCheck className="h-5 w-5" /> Book Free Site Visit
          </button>
        </Reveal>
      </div>
      <div className="mt-12 grid gap-5 md:grid-cols-3">
        <Reveal><Row icon={MapPin} label="Address" value={CONTACT.address} href={CONTACT.mapLink} testId="contact-address" external /></Reveal>
        <Reveal delay={0.08}><Row icon={Phone} label="Call" value={CONTACT.phoneDisplay} href={CONTACT.tel} testId="contact-phone-link" /></Reveal>
        <Reveal delay={0.16}><Row icon={WhatsAppIcon} label="WhatsApp" value="Send a message" href={CONTACT.whatsapp} testId="contact-whatsapp-link" external /></Reveal>
      </div>
    </div>
  </section>
);
